module.exports = __webpack_public_path__ + "img/006.fa43c457.jpg";